import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import EditIcon from "@static/core/icons/icon-edit.svg?react";
import { Contact } from "@type/core/dashboard/dashboard.types";
import { ColumnsType } from "antd/lib/table/interface";
import i18n from "i18next";
import { Dispatch, SetStateAction } from "react";
import { formatCategory } from "@/utils/helpers/format-helper";

export const columns = (
  setIsDeleteContactOpen: Dispatch<SetStateAction<boolean>>,
  setContact: Dispatch<SetStateAction<Contact | undefined>>,
  onRemoveCategory: (contact: Contact, category: string) => void,
  setIsEditContactOpen: Dispatch<SetStateAction<boolean>>,
): ColumnsType<Contact> => [
  {
    title: i18n.t("contacts.headers.firstname"),
    dataIndex: "firstname",
    sorter: (a, b) => a.firstname.localeCompare(b.firstname),
    defaultSortOrder: "ascend",
    showSorterTooltip: false,
    render: (text: string) => {
      return <span data-test="table-item">{text}</span>;
    },
  },
  {
    title: i18n.t("contacts.headers.lastname"),
    dataIndex: "lastname",
    sorter: (a, b) => a.lastname.localeCompare(b.lastname),
    showSorterTooltip: false,
  },
  {
    title: i18n.t("contacts.headers.email"),
    dataIndex: "email",
    sorter: (a, b) => a.email.localeCompare(b.email),
    showSorterTooltip: false,
  },
  {
    title: i18n.t("contacts.headers.phone"),
    dataIndex: "phone",
    sorter: (a, b) => a.phone.localeCompare(b.phone),
    showSorterTooltip: false,
  },
  {
    title: i18n.t("contacts.headers.companyName"),
    dataIndex: "companyName",
    sorter: (a, b) => a.companyName.localeCompare(b.companyName),
    showSorterTooltip: false,
  },
  {
    title: i18n.t("contacts.headers.category"),
    dataIndex: "id",
    render: (_, contact) => {
      const category = contact.category;
      return formatCategory(category ?? "", (_, cat) =>
        onRemoveCategory(contact, cat),
      );
    },
  },
  {
    dataIndex: "id",
    width: 108,
    render: (_, contact) => {
      return (
        <div className="d-flex align-items-center justify-content-center gap-24">
          <EditIcon
            className="picto icon-30"
            data-test="button"
            data-alt={i18n.t("buttons.edit")}
            onClick={() => {
              setContact(contact);
              setIsEditContactOpen(true);
            }}
          />
          <DeleteIcon
            className="picto icon-30"
            onClick={() => {
              setContact(contact);
              setIsDeleteContactOpen(true);
            }}
          />
        </div>
      );
    },
  },
];
